import React, { useMemo } from 'react';
import SourceType from 'types/Source';
import sourceTypes from 'consts/sourceTypes';
import makeStyles from '@material-ui/core/styles/makeStyles';

// Components
import InfoCard from 'components/InfoCard';
import HelpArticleLink from 'components/Page/HelpArticleLink';

interface Props {
  source: SourceType;
}

function MappingsCard({ source }: Props) {
  const classes = useStyles();

  const Subheader = useMemo(() => {
    let elem = null;
    elem = (
      <>
        Mappings tell us which properties from your data source that Sift should import when running
        a data sync. We require a few different things to get started, but you can always come back
        in the future after creating new Sift attributes, or if you want to start importing a new
        piece of information to your employee profiles.
      </>
    );
    if (!source.isPrimary) {
      elem = (
        <>
          Mappings tell us which properties from your data source that Sift should import when
          running a data sync. In a Complementary Source, all imported data will append to existing
          profiles created by your Primary Source.
        </>
      );
    }

    return elem;
  }, [source.type]);

  return (
    <InfoCard
      title="Assign your Mappings"
      subheader={
        <div>
          <div className={classes.divider} />
          {Subheader}
          <div className={classes.divider} />
          <HelpArticleLink
            link={'https://help.justsift.com/en/articles/3839095-mapping-your-incoming-data'}
            text="Learn more about mappings ❯"
          />
        </div>
      }
      subheaderClassName={classes.subheader}
    />
  );
}

const useStyles = makeStyles(theme => {
  return {
    subheader: {
      width: '100%',
    },
    divider: {
      marginTop: theme.spacing(3),
    },
  };
});

export default MappingsCard;
